import React from 'react';

import { blue, blueGrey, lightBlue } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useCustomTheme = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  return React.useMemo(() => {
    return createTheme({
      palette: {
        mode: prefersDarkMode ? 'dark' : 'light',
        primary: {
          light: '#58a5ef',
          main: lightBlue[800],
          dark: '#004c8b',
          contrastText: '#ffffff',
        },
        secondary: {
          light: '#80d6ff',
          main: blue[400],
          dark: '#0077c2',
          contrastText: '#ffffff',
        },
        tertiary: {
          light: '#62727b',
          main: blueGrey[800],
          dark: '#102027',
          contrastText: '#ffffff',
        },
        error: {
          main: '#c62828',
        },
        warning: {
          main: '#ffab00',
        },
        info: {
          main: blue[400],
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
      },
      typography: {
        h5: {
          fontWeight: '500',
        },
        fontFamily: [
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),
      },
    });
  }, [prefersDarkMode]);
};

export default useCustomTheme;
